import React, { Fragment, useState } from 'react';
import { Box, TextField, Autocomplete, Button, Dialog, CircularProgress } from '@mui/material';
import KioskMap from '../components/KioskMap'
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from '../context/FormContext';

function ReceivingMap({ type }) {
    const { formData, updateField, errors } = useForm();
    const [kioskmap, setKioskMap] = useState(false);
    const [lockers, set_lockers] = useState([]);
    const [loading, setLoading] = useState('');
    const [restoredTerminalID, setRestoredTerminalID] = useState(false);
    var param_type = (type.includes('_locker')) ? "lockers" : ((type.includes('_pp')) ? "pickup point" : "kiosk");

    const getLockers = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_ENDPOINT}guest/lockers-data?type=${param_type}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch data");
            }

            if (response.status === 200) {
                const data = await response.json();
                const mapped_lockers = data.map(locker => {
                    const {
                        latitude = null,
                        longitude = null,
                        name = "",
                        code = "",
                        type,
                        openinghours = []
                    } = locker || {}
                    const { formatted_address = "", ...restssof_address } = locker.detailed_address || {}

                    return {
                        "id": code,
                        "lockerId": code,
                        "name": name,
                        "isActive": true,
                        "lstTypesBoxes": locker?.lstTypesBoxes,
                        "position": {
                            "lat": parseFloat(latitude),
                            "lng": parseFloat(longitude)
                        },
                        "type": type,
                        "address": {
                            "address": formatted_address,
                            "latitude": parseFloat(latitude),
                            "longitude": parseFloat(longitude),
                            ...restssof_address
                        },
                        "standardHours": openinghours.map(day => {
                            return {
                                day: day?.day,
                                openingTime: day?.open_time,
                                closingTime: day?.close_time
                            }
                        })
                    }
                });
                localStorage.setItem(
                    "lockers",
                    JSON.stringify(mapped_lockers)
                );
            } else {
                console.log(response?.message || "Request code failed!", {
                    variant: "error",
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error as needed
        } finally {
            setLoading(false);
        }
    };
    
    const stored_lockers = localStorage.getItem('lockers');

    React.useEffect(() => {
        getLockers()
        if (stored_lockers) {
            const lockersInfo = JSON.parse(stored_lockers);
            if (lockersInfo && lockersInfo.length > 0) {
                const _lockers = lockersInfo.filter(data => data.lockerId);
                set_lockers(_lockers);
            }   
        }
    }, [stored_lockers]);

    React.useEffect(() => {
        if (restoredTerminalID) return;
        if(type.includes('pp_') && !type.includes('_door')){
            const saved = localStorage.getItem('shipment_details');
            if (!saved) return;
            
            const payload = JSON.parse(saved);
            const terminalId = payload?.delivery_address?.terminal_id;
             
            const matchedLocker = lockers.find(
                locker => String(locker.id) === String(terminalId)
            );
            if (matchedLocker) {
                handleCloseKioskMap(matchedLocker, false);
                setRestoredTerminalID(true);
            }            
        }
    }, [lockers, type, restoredTerminalID]);

    const handleKioskMap = () => {
        setKioskMap(true)
    }

    const handleCloseKioskMap = (selectedLocker,isMap = true) => {
        setKioskMap(false)
        updateField('selectedLocker',selectedLocker);
        if (selectedLocker) {
            updateField('selectedName', selectedLocker?.name)
        }
    }

    return (
        <Fragment>
            {
                (loading === true) ? (
                    <div className='flex flex-col justify-center justify-items-center items-center'>
                        <div>
                            <CircularProgress className="progress" color="secondary" />
                        </div>
                        <div>
                            <h3 className='font-semibold mt-1 text-blue-400'>Preparing {(type.includes('_locker')) ? "Lockers" : ((type.includes('_pp')) ? "Point" : "Kiosk")} Location on Map. Please wait.</h3>
                        </div>
                    </div>
                ) : (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Autocomplete
                            value={formData.selectedLocker || null}
                            disablePortal
                            id={type}
                            options={lockers}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option?.name || ''}
                            sx={{ width: '75vw' }}
                            onChange={(event, locker_selected) => {
                                handleCloseKioskMap(locker_selected,false);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={`Select a ${(type === 'kiosk_to_kiosk' || type === 'pp_to_kiosk') ? 'Kiosk' : ((type === 'pp_to_pp' || type === 'kiosk_to_pp') ? 'Point' : 'Locker')}`}
                                    required
                                    error={!!errors.selectedLocker}
                                    helperText={errors.selectedLocker || ''}
                                />
                            )}
                        />
                        <Button
                            variant='contained'
                            sx={{
                                width: '25vw',
                                backgroundColor: '#ed7d31'
                            }}
                            onClick={() => handleKioskMap()}
                        >
                            {(type === 'kiosk_to_kiosk' || type === 'pp_to_kiosk') ? 'Kiosk' : ((type === 'pp_to_pp' || type === 'kiosk_to_pp') ? 'Point' : 'Locker')} Map
                        </Button>

                        <Dialog open={kioskmap} onClose={() => setKioskMap(false)} fullScreen>
                            <AppBar sx={{ position: 'fixed' }}>
                                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#264796' }}>
                                    <Typography>{(type.includes('_locker')) ? 'Locker' : ((type.includes('_pp')) ? 'Point' : 'Kiosk')} Map</Typography>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        onClick={() => setKioskMap(false)}
                                        aria-label="close"
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Toolbar>
                            </AppBar>
                            <Box sx={{ mt: 7 }}>
                                <KioskMap mapType={(type.includes('_locker')) ? 'locker' : ((type.includes('_pp')) ? 'point' : 'kiosk')} onClose={handleCloseKioskMap} />
                            </Box>
                        </Dialog>
                    </Box>
                )
            }
        </Fragment>
    );
}

export default ReceivingMap;
